import { useCallback } from 'react';
import { graphql } from 'react-relay';

import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

import type {
	GetConfluenceSpacesQuery,
	GetConfluenceSpacesQueryVariables,
} from './gql/__types__/GetConfluenceSpaceQuery.ts';

interface MapConfluenceSpaceKeysToIdsProps {
	setQueryParamsCallback: (params: any, replace?: boolean) => void;
	queryParams: Record<string, any>;
}

export const useGetSpaceIdsFromSpaceKeys = ({
	setQueryParamsCallback,
	queryParams,
}: MapConfluenceSpaceKeysToIdsProps): ((spaceKeys: string[]) => Promise<string[]>) => {
	const getSpaceIdsFromSpaceKeys = useCallback(
		async (spaceKeys: string[]): Promise<string[]> => {
			if (spaceKeys.length === 0) return [];
			try {
				const query = await queryInterop<
					GetConfluenceSpacesQuery,
					GetConfluenceSpacesQueryVariables
				>({
					query: graphql`
						query useGetSpaceIdsFromSpaceKeysQuery($spaceKeys: [String]) {
							spaces(spaceKeys: $spaceKeys) {
								nodes {
									id
								}
							}
						}
					`,
					variables: {
						spaceKeys,
					},
				});
				const spaceIds: string[] = (query.data.spaces?.nodes ?? [])
					.map((node) => node?.id)
					.filter((id): id is string => !!id);
				return spaceIds;
			} catch {
				// TODO: log error using what Confluence uses in place of Sentry
				//	likely in follow up ticket

				// drop the spaces query param
				setQueryParamsCallback(
					{
						...queryParams,
						spaces: undefined,
					},
					true,
				);
			}
			return [];
		},
		[queryParams, setQueryParamsCallback],
	);
	return getSpaceIdsFromSpaceKeys;
};
